// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedFcpMode2_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 17.9992H17.0181V16.5292L19.5227 13.9952C20.0264 13.4725 20.4321 13.0385 20.7399 12.6932 21.0478 12.3386 21.2716 12.0212 21.4116 11.7412 21.5515 11.4519 21.6214 11.1439 21.6214 10.8172 21.6214 10.4159 21.5095 10.1172 21.2856 9.92123 21.0711 9.72523 20.7773 9.62723 20.4041 9.62723 20.0217 9.62723 19.6486 9.7159 19.2848 9.89323 18.921 10.0706 18.5386 10.3226 18.1375 10.6492L16.9901 9.29123C17.27 9.04857 17.5731 8.8199 17.8996 8.60524 18.2261 8.38124 18.5992 8.20391 19.019 8.07324 19.448 7.93324 19.9611 7.86324 20.5581 7.86324 21.211 7.86324 21.7707 7.98457 22.2371 8.22724 22.7128 8.46057 23.0766 8.78257 23.3284 9.19324 23.5896 9.59457 23.7202 10.0519 23.7202 10.5652 23.7202 11.1159 23.6083 11.6199 23.3844 12.0772 23.1699 12.5346 22.8527 12.9872 22.433 13.4352 22.0225 13.8832 21.5235 14.3779 20.9358 14.9192L19.6486 16.1232V16.2212H24V17.9992ZM10.4938 13.9999 11.4933 16.9999H3.49795L4.49736 13.9999H10.4938ZM4.49736 20.9999 3.49795 17.9999H11.4933L10.4938 20.9999H4.49736ZM7.4956 9.99995C8.32354 9.99995 8.99472 9.32838 8.99472 8.49996 8.99472 7.67153 8.32354 6.99996 7.4956 6.99996 6.66766 6.99996 5.99648 7.67153 5.99648 8.49996 5.99648 9.32838 6.66766 9.99995 7.4956 9.99995Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.999995V23.9999H14.9912V0.999995H0ZM12.9924 3.99998H1.99883V21.9999L12.9924 21.9686V3.99998Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedFcpMode2 is a generated icon component.
 */
let IconMedFcpMode2 = IconMedFcpMode2_1 = class IconMedFcpMode2 extends IconBaseElement {
    render() {
        return html `${IconMedFcpMode2_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedFcpMode2.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedFcpMode2 = IconMedFcpMode2_1 = __decorate([
    customElement('zui-icon-med-fcp-mode-2')
], IconMedFcpMode2);
export { IconMedFcpMode2 };
